import { AutoMap } from "@automapper/classes";
import { CanalDTO } from "./canal.dto";

export class EndoscopeDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    zoneSalle: string = ''
    @AutoMap()
    samplingDate?: string;
    @AutoMap()
    marque: string = ''
    @AutoMap()
    modele: string = ''
    @AutoMap()
    numSerie: string = ''
    @AutoMap()
    numAppareil: string = ''
    
    // #region SPECIFIC TO ENDOSCOPE //
    @AutoMap()
    typeEndoscope: number = 0
    @AutoMap()
    motifPrelevement: number = 0
    @AutoMap()
    traitement: number = 0
    // @AutoMap()
    // cycleTraitement: number = 0
    @AutoMap()
    typeEauRincage: number = 0
    @AutoMap()
    dateDernierLavage?: string
    @AutoMap()
    numeroESET: string = ''
    @AutoMap()
    dateStockageESET?: string
    @AutoMap()
    conditionPrelevement: number = 0
    @AutoMap()
    conditionStockage: number = 0
    @AutoMap(() => [CanalDTO])
    canalEndoscopeList: CanalDTO[] = [];
    //#endregion
}